/**
 * @generated SignedSource<<9629845bb84433152cd742d842beb83b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetFileInput = {
  files: ReadonlyArray<FileInput>;
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
  slideshowDuration?: number | null;
  title?: string | null;
};
export type FileInput = {
  fileId: string;
  pageNumbers?: ReadonlyArray<number> | null;
};
export type WAFileMutation$variables = {
  input: CreateWidgetFileInput;
  storecastId: string;
};
export type WAFileMutation$data = {
  readonly dashboard: {
    readonly createWidgetFile: {
      readonly id: string;
    };
  };
};
export type WAFileMutation = {
  response: WAFileMutation$data;
  variables: WAFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetFile",
        "kind": "LinkedField",
        "name": "createWidgetFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAFileMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAFileMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "335c8a8a787c096ea23662a312958fbe",
    "id": null,
    "metadata": {},
    "name": "WAFileMutation",
    "operationKind": "mutation",
    "text": "mutation WAFileMutation(\n  $storecastId: ID!\n  $input: CreateWidgetFileInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetFile(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "054cd0b49aa974e2b2dfd41b8462245a";

export default node;
